import React from 'react';
import { LayoutProps, RankedTester, rankWith, uiTypeIs, VerticalLayout } from '@jsonforms/core';
import { ChakraLayoutRenderer, ChakraLayoutRendererProps } from './ChakraLayout';
import configuredAreEqual from '../utils/configuredAreEqual';
import { withNamedJsonFormsLayoutProps } from '@/forms-renderers/chakra-ui/utils/withNamedJsonFormsHOC';
import { namedMemo } from '@/utils/namedMemo';

export const ChakraVerticalLayoutRenderer = namedMemo(
    'ChakraVerticalLayoutRenderer',
    ({ uischema, schema, path, enabled, visible, renderers, cells }: LayoutProps) => {
        const uischemaOption = uischema.options;
        const layout = uischema as VerticalLayout;
        const childProps: ChakraLayoutRendererProps = {
            elements: layout.elements,
            width: uischemaOption?.w,
            columns: uischemaOption?.columns ?? 1,
            rows: uischemaOption?.rows ?? layout.elements.length,
            autoRows: uischemaOption?.autoRows,
            gap: uischemaOption?.gap,
            schema,
            path,
            enabled,
            visible,
        };

        return <ChakraLayoutRenderer {...childProps} renderers={renderers} cells={cells} />;
    },
    configuredAreEqual({ ignore: ['data'] }),
);

export const chakraVerticalLayoutTester: RankedTester = rankWith(1, uiTypeIs('VerticalLayout'));

export default withNamedJsonFormsLayoutProps(ChakraVerticalLayoutRenderer);
